import React from "react";
import { object } from "prop-types";

import ComponentContainer from "../../layouts/component-container";
import { Widgets } from "../../widgets";
import LeftImageRightNews from "../../molecules/LeftImageRightNews";
import DfpContainer from "../../ads/dfp-container";
import { DfpComponent } from "../../ads/dfp-component";
import NewsWithImage from "../../molecules/NewsWithImage";

import { useDevice } from "../../utils/react-utils";
import { componentProps } from "../../utils/utils";

import "./sixStories1AdWithTagSearch.m.css";

const SixStories1AdWithTagSearch = ({ collection }) => {
  if (!(collection && collection.items && collection.items.length)) return null;

  const { items = [], adSlot, widgetUrl = "", widgetHeight = "" } = componentProps(collection);

  const [first, ...others] = items.map(({ story }) => story);
  const threeStories = others.slice(0, 3);
  const lastTwo = others.slice(3);
  const { mobile, tab, desktop } = useDevice();

  return (
    <ComponentContainer styleName="base" collection={collection}>
      <div styleName="wrapper">
        <Widgets
          locationIcon={true}
          enableTheme={true}
          styleName="widget"
          widgetUrl={widgetUrl}
          widgetHeight={widgetHeight}
        />

        <div styleName="container">
          <div styleName="first-column">
            <NewsWithImage
              styleName="first-story"
              imageType="image4x3"
              aspectRatio={[4, 3]}
              story={first}
              showExcerpt={true}
              widths={[370, 480, 640]}
            />
            {tab && (
              <DfpContainer>
                <DfpComponent
                  type={adSlot}
                  slotId={adSlot + "-SixStories1AdWithTagSearch"}
                  layoutName="SixStories1AdWithTagSearch"
                  collectionSlug={collection.slug}
                />
              </DfpContainer>
            )}
          </div>
          <div styleName="others">
            <div styleName="middle-column">
              {threeStories.map((story, index) => (
                <LeftImageRightNews
                  styleName="story"
                  key={index}
                  story={story}
                  showExcerpt={tab || desktop}
                  widths={[180, 255, 255]}
                />
              ))}
            </div>
            <div styleName="last-column">
              <div styleName="last-column-wrapper">
                <div styleName="last-column-items">
                  {lastTwo.map((story, index) => (
                    <LeftImageRightNews
                      styleName="story"
                      key={index}
                      story={story}
                      showExcerpt={global.isTab}
                      widths={[195, 270, 240]}
                    />
                  ))}
                </div>

                {(mobile || desktop) && (
                  <DfpContainer styleName="last-column-ad">
                    <DfpComponent
                      type={adSlot}
                      slotId={adSlot + "-SixStories1AdWithTagSearch"}
                      layoutName="SixStories1AdWithTagSearch"
                      collectionSlug={collection.slug}
                    />
                  </DfpContainer>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ComponentContainer>
  );
};

SixStories1AdWithTagSearch.propTypes = {
  collection: object,
};

SixStories1AdWithTagSearch.storyLimit = 6;

export default SixStories1AdWithTagSearch;
